import script from "./ForwardingSetupView.vue?vue&type=script&setup=true&lang=js"
export * from "./ForwardingSetupView.vue?vue&type=script&setup=true&lang=js"

import "./ForwardingSetupView.vue?vue&type=style&index=0&id=02253de5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02253de5"]])

export default __exports__